import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ConfirmationBodyContainer from '../containers/ConfirmationBodyContainer';
import BackToListing from './BackToListing';
import ConfirmationContent from './ConfirmationContent';
import ConfirmationHeader from './ConfirmationHeader';
import ConfirmationReservationInfo from './ConfirmationReservationInfo';
import FocusTrap from '../../../../shared/FocusTrap';
import EmbedFooter from '../../../components/EmbedFooter';
import { RoktPlaceholder } from '../../../containers/Analytics/Rokt';
import CartSummaryContainer from '../../../views/checkout/containers/CartSummaryContainer';
import { ConfirmationCartSummarySkeleton } from './ConfirmationCartSummarySkeleton';
import Translation from '../../../../shared/Translation';
import {wrappedFetch} from "../../../helpers/fetch";
import { withRouterCompat } from '../../../helpers/withRouterCompat';

class Confirmation extends Component {
  confirmationOverlay = React.createRef();

  componentDidMount() {
    this.confirmationOverlay?.current?.focus();
    if (this.props.queueIt) {
      fetch('/iframe-queue-cancel/' + this.props.listingSlug, { mode: 'no-cors'}).then((response)=>{});
    }
  }
  goBack = async(e) => {
    e.preventDefault();

    if (this.props.isMembershipAvailable) {
        await wrappedFetch(`/api/memberships/?update_reservation=false`, {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    if(this.props.queueOn === true) {
        setTimeout(() => {
            localStorage.clear();
            if (this.props.isEmbed) {
                parent.location.reload();
            } else {
                window.location.reload();
            }
        }, 0);
    }

    if(this.props.isMembershipAvailable) {
        this.props.membershipSignOut();
        this.props.setHasMembershipContext(false);
        this.props.setSkipMembership(false);
    }
    this.props.navigate('/');
  }


  render() {
    return (
      <FocusTrap
        fallback={'.confirmation-wrap'}
        focusTrapOptions={{
          allowOutsideClick: true,
        }}
        active={this.props.activeTrap}
      >
        <dialog
          className="confirmation-wrap"
          aria-modal="true"
          aria-labelledby="confirmation-page-header"
          tabIndex="-1"
          ref={this.confirmationOverlay}
        >
          <header className="confirmation__header">
            <button className='button--link' onClick={this.goBack}>
              <i className="icon-close" aria-hidden="true"></i>
              <Translation>{'checkout__close'}</Translation>
            </button>
          </header>
          <div className="confirmation">
            <div className="confirmation__contents">
              <main className="confirmation__main">
                <ConfirmationHeader pending={!!this.props.pending}>
                    <ConfirmationReservationInfo
                      confirmationNumber={this.props.confirmationNumber}
                      email={this.props.email}
                      pending={!!this.props.pending}
                      showTooltip={this.props.showTooltip}
                      ticketsUrl={this.props.ticketsUrl}
                    />
                </ConfirmationHeader>
                <ConfirmationBodyContainer>
                  <ConfirmationContent content={this.props.content} />
                  <BackToListing queueOn={this.props.queueOn} goBack={this.goBack} />
                  <RoktPlaceholder />
                </ConfirmationBodyContainer>
              </main>
              <aside className="confirmation__aside">
                {!this.props.isFetching && <CartSummaryContainer hideEventDateTime={this.props.hideEventDateTime} navigate={this.props.navigate}/>}
                {this.props.isFetching && <ConfirmationCartSummarySkeleton />}
              </aside>
            </div>
            <EmbedFooter />
          </div>
        </dialog>
      </FocusTrap>
    );
  }
}

Confirmation.propTypes = {
  confirmationNumber: PropTypes.string,
  email: PropTypes.string,
  events: PropTypes.arrayOf(PropTypes.object),
  ticketsUrl: PropTypes.string,
  content: PropTypes.string,
  queueOn: PropTypes.bool,
  queueIt: PropTypes.bool,
  hideEventDateTime: PropTypes.bool,
  onClickShareTwitter: PropTypes.func,
  onClickShareFacebook: PropTypes.func,
  facebookAppId: PropTypes.string,
  listingSlug: PropTypes.string,
  activeTrap: PropTypes.bool,
  showTooltip: PropTypes.bool,
  isMembershipAvailable: PropTypes.bool,
};

Confirmation.defaultProps = {
  content: '',
  listingSlug: '',
  activeTrap: true,
};

export default withRouterCompat(Confirmation);
